import api from './Config/axios';



// Global api
export const CheckAccount = async (mobile) => {
    const response = await api.post("/CheckAccount-assocaite-with-number", {
        mobile,
    });

    return response.data;
};

export const Login_Account = async (mobile, userCode, password, acc_type, uid, latitude, longitude) => {
    const response = await api.post("/user-login", {
        mobile, userCode, password, acc_type, uid, latitude, longitude
    });

    return response.data;
};

export const Get_User_Details = async () => {
    const response = await api.get("/user-get-profile", {
    });

    return response.data;
}

export const Get_User_Wallet_Details = async () => {
    const response = await api.get("/get-user-wallet-details", {
    });

    return response.data;
}

export const User_Topin_Request = async (body) => {
    const response = await api.post(
        "/user-top-in-request",
        body,
    );

    return response.data;
};

export const Get_user_topin_requests = async (startDate, endDate) => {

    const response = await api.get("/get-user-top-in-req", {
        params: {
            startDate,
            endDate
        }
    });

    return response.data;
}

export const Get_user_ledger = async (startDate, endDate) => {

    const response = await api.get("/get-user-ledger", {
        params: {
            startDate,
            endDate
        }
    });

    return response.data;
}

export const Sendotp = async (purpose) => {

    const response = await api.post("/send-verification-otp", {
        purpose
    });

    return response.data;
}

export const ChangePassword = async (body) => {

    const response = await api.post("/change-password",
        body
    );

    return response.data;
}

export const ChangeMpin = async (body) => {

    const response = await api.post("/change-mpin",
        body
    );

    return response.data;
}

export const Sendotp_Forget_Password = async (body) => {

    const response = await api.post("/send-verification-otp-forget",
        body
    );

    return response.data;
}

export const ForgetPassword = async (body) => {

    const response = await api.put("/forget-password",
        body
    );

    return response.data;
}

export const Admin_Banks_get = async () => {
    const response = await api.get("/get-admin-banks", {
    });

    return response.data;
}

export const Get_Portal_Updates = async () => {
    const response = await api.get("/get-published-updates", {
    });

    return response.data;
}


// Retailer api
export const Find_Retailer_by_mobile_for_wtow_transfer = async (mobile) => {
    const response = await api.post("/find-retailer-by-mobile-for-wtow", {
        mobile,
    });

    return response.data;
};

export const Ret_to_Ret_wallet_transfer = async (body) => {
    const response = await api.post("/transfer-ret-to-ret-wallet",
        body,
    );

    return response.data;
};

export const Get_Ret_to_Ret_wallet_transfer_history = async () => {
    const response = await api.get("/get-ret-to-ret-wallet-transfer-history", {
    });

    return response.data;
}

export const Get_Dashboard_Details = async () => {
    const response = await api.get("/get-retailer-dashboard-details", {
    });

    return response.data;
}

export const Verify_bank_penny_drop_request = async (body) => {
    const response = await api.post("/verify/bank/penny-drop",
        body,
    );

    return response.data;
};

export const Make_payout_request = async (body) => {
    const response = await api.post("/create/payout/request",
        body,
    );

    return response.data;
};

export const Get_Saved_Beneficiary = async (page, limit) => {
    const response = await api.get(`/get/saved-bene?page=${page}&limit=${limit}`, {
    });

    return response.data;
}

export const Get_Payout_History = async (startDate, endDate) => {

    const response = await api.get("/get/ret-payout-history", {
        params: {
            startDate,
            endDate
        }
    });

    return response.data;
}

export const Get_Verify_History = async (startDate, endDate) => {

    const response = await api.get("/get/ret-verification-history", {
        params: {
            startDate,
            endDate
        }
    });

    return response.data;
}



// Distributor api call

export const Get_Dashboard_Details_dist = async () => {
    const response = await api.get("/get-distributor-dashboard", {
    });

    return response.data;
}

export const get_dist_and_retailers = async () => {
    const response = await api.get("/get-mapped-users", {
    });

    return response.data;
}

export const Find_Distributor_by_mobile_for_wtow_transfer = async (mobile) => {
    const response = await api.post("/find-distributor-by-mobile-for-wtow", {
        mobile,
    });

    return response.data;
};

export const Dist_to_Dist_wallet_transfer = async (body) => {
    const response = await api.post("/transfer-dist-to-dist-wallet",
        body,
    );

    return response.data;
};

export const Get_Dist_to_Dist_wallet_transfer_history = async () => {
    const response = await api.get("/get-dist-to-dist-wallet-transfer-history", {
    });

    return response.data;
}

export const Find_user_for_fund_transfer = async () => {
    const response = await api.get("/find-user-for-fund-transfer-mapped", {
    });

    return response.data;
}

export const fund_transfer_to_user = async (body) => {
    const response = await api.post("/fund-transfer-to-user-mapped",
        body,
    );

    return response.data;
};

export const fund_revert_from_user = async (body) => {
    const response = await api.put("/fund-revert-from-user-mapped",
        body,
    );

    return response.data;
};

export const get_fund_transfer_history = async () => {
    const response = await api.get("/get-fund-transfer-history-mapped", {
    });

    return response.data;
}

export const get_users_ledger = async (startDate, endDate, reqID) => {
    const response = await api.get("/get-users-ledger", {
        params: {
            startDate,
            endDate,
            reqID
        }
    });

    return response.data;
}





// Admin API

export const Get_Admin_Dashboard_Details = async () => {
    const response = await api.get("/get-admin-dashboard-details", {
    });

    return response.data;
}

export const Get_users_topin_requests = async (startDate, endDate) => {
    const response = await api.get("/get-all-users-top-in-req", {
        params: {
            startDate,
            endDate,
        }
    });

    return response.data;
}

export const Update_user_topin_requests = async (body) => {
    const response = await api.put("/update-user-top-in-req",
        body,
    );

    return response.data;
};

export const Get_All_Users = async () => {
    const response = await api.get("/get-all-users", {
    });

    return response.data;
}

export const Revert_Fund = async (body) => {
    const response = await api.post("/revert-fund",
        body,
    );

    return response.data;
};

export const get_revert_history = async () => {
    const response = await api.get("/get-revert-history", {
    });

    return response.data;
}

export const Admin_wallet_self_topin = async (body) => {
    const response = await api.post("/self-top-in-request",
        body,
    );

    return response.data;
};

export const Admin_wallet_transfer = async (body) => {
    const response = await api.post("/transfer-wallet-to-wallet",
        body,
    );

    return response.data;
};

export const get_Wallet_Transfer_history = async () => {
    const response = await api.get("/get-wallet-transfer-history", {
    });

    return response.data;
}

export const Get_All_Users_Ledgers = async (startDate, endDate, reqID) => {
    const response = await api.get("/get-queried-user-ledger", {
        params: {
            startDate,
            endDate,
            reqID
        }
    });

    return response.data;
}

export const User_Swap = async (body) => {
    const response = await api.put("/swap-user",
        body,
    );

    return response.data;
};

export const Get_Individual_user_wallet_details = async (userID) => {
    //console.log(userID);

    const response = await api.get(`/get-individual-user-wallet-details/${userID}`, {
    });

    return response.data;
}

export const Master_Dist_Signup = async (body) => {
    const response = await api.post("/create-master-dist",
        body,
    );

    return response.data;
};

export const Distributor_Signup = async (body) => {
    const response = await api.post("/create-distributor",
        body,
    );

    return response.data;
};

export const Retailer_Signup = async (body) => {
    const response = await api.post("/create-retailer",
        body,
    );

    return response.data;
};

export const Update_user_wallet_status = async (body) => {
    const response = await api.put("/update-user-wallet-status",
        body,
    );

    return response.data;
};

export const Update_user_wallet_hold_balance = async (body) => {
    const response = await api.put("/update-user-wallet-hold-balance",
        body,
    );

    return response.data;
};

export const Update_Master_dist_details = async (body) => {
    const response = await api.put("/update-user-master-distributor-details",
        body,
    );

    return response.data;
};

export const Update_Distributor_details = async (body) => {
    const response = await api.put("/update-user-distributor-details",
        body,
    );

    return response.data;
};

export const Update_Retailer_details = async (body) => {
    const response = await api.put("/update-user-retailer-details",
        body,
    );

    return response.data;
};

export const Revert_AdvanceCredit_Fund = async (body) => {
    const response = await api.put("/take-advance-credit-revert",
        body,
    );

    return response.data;
};

export const Admin_Bank_Add = async (body) => {
    const response = await api.post("/add-admin-bank-details",
        body,
    );

    return response.data;
};

export const Admin_Bank_Delete = async (BankID) => {
    //console.log(userID);
    const response = await api.delete(`/del-admin-banks-details/${BankID}`, {
    });

    return response.data;
}

export const Portal_Configuration = async (body) => {
    const response = await api.post("/set-portal-configuration",
        body,
    );

    return response.data;
};

export const Get_Portal_Configuration = async () => {
    const response = await api.get("/get-portal-configurations", {
    });

    return response.data;
}

export const Portal_Updates = async (body) => {
    const response = await api.post("/publish-update",
        body,
    );

    return response.data;
};

export const Get_LoginLogs = async (page, limit) => {
    const response = await api.get(`/get-all-login-logs?page=${page}&limit=${limit}`, {
    });

    return response.data;
}

export const Get_FundLogs = async (page, limit) => {
    const response = await api.get(`/get-all-fund-logs?page=${page}&limit=${limit}`, {
    });

    return response.data;
}

export const Get_RevertLogs = async (page, limit) => {
    const response = await api.get(`/get-all-revert-logs?page=${page}&limit=${limit}`, {
    });

    return response.data;
}

export const SubAdmin_Signup = async (body) => {
    const response = await api.post("/create-sub-admin",
        body,
    );

    return response.data;
};

export const Get_All_SubAdmin = async () => {
    const response = await api.get("/get-all-sub-admins", {
    });

    return response.data;
}